import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {

  constructor(private router : Router) { }

  ngOnInit() {
  }


  /**
   * We can also send many other information in URL
   * Using this method if we want to open this page from facebook then we have to 
   * get many other inforation also
   */
  initPayment(plan_id){
    this.router.navigate(['payment/'+plan_id]);
  }

}
